import { DescriptionRounded, DownloadingRounded, CheckCircleRounded, DeleteRounded } from '@mui/icons-material';
import { Typography, LinearProgress } from '@mui/material';
import { Box } from '@mui/system';
import { FileType } from 'Application/models';
import { convertBytesToMB } from 'Application/utils';
import { FC, useEffect, useState } from 'react';

interface UploadedFileProps {
  fileType: FileType;
  fileSize: string;
  fileName: string;
  onDeleteFile: (index: number) => void;
  index: number;
}

export const UploadedFile: FC<UploadedFileProps> = ({ index, fileType, fileSize, fileName, onDeleteFile }) => {
    const [progress, setProgress] = useState<number>(0);

    useEffect(() => {
        let interval: NodeJS.Timeout;
        
        if (progress < 100) {
            interval = setInterval(() => {
                setProgress((prevProgress) => {
                    if (prevProgress < 100) {
                        return prevProgress + 5;
                    } else {
                        clearInterval(interval);
                        return 100;
                    }
                });
            }, 100);
        }
        return () => clearInterval(interval);
    }, [progress]);

    return (
        <Box className="flex flex-row items-center w-full hover:cursor-pointer my-3">
            <Box className="flex h-20 px-5 py-2 border border-gray-200 rounded-md w-11/12">
                <Box className="flex flex-col justify-evenly w-1/6 h-full">
                    <DescriptionRounded color="primary" />
                    <Typography className="text-[12px] font-semibold">{fileType}</Typography>
                </Box>
                <Box className="flex flex-col justify-evenly w-5/6 h-full">
                    <Box className="flex justify-between items-center">
                        <Box className="flex flex-col">
                            <Typography className="text-[13px]">{fileName}</Typography>
                            <Typography className="font-semibold text-[12px]">{convertBytesToMB(fileSize)}</Typography>
                        </Box>
                        {progress < 100 ? (
                            <DownloadingRounded fontSize="small" color="primary" />
                        ) : (
                            <CheckCircleRounded fontSize="small" color="primary" />
                        )}
                    </Box>
                    <Box className="flex justify-between items-center w-full">
                        <LinearProgress color="primary" variant="determinate" 
                        className="w-4/5 rounded-md" value={progress} />
                        <Typography className="text-[13px]">{progress}%</Typography>
                    </Box>
                </Box>
            </Box>
            <Box className="flex justify-center items-center w-1/12">
                <DeleteRounded onClick={() => onDeleteFile(index)} fontSize="small" color="error" />
            </Box>
        </Box>
    );
};
